export const LUPA_TIMELINEV3 = 'components/LupaTimelineV3';

export const i18n = {
  en: {
    validation: {
      dateInFutureOrEmpty: 'Empty field or date in the future cannot be marked as actual',
      fieldFlagged:
        'A material change has been recorded either in the issuance end date and/or in the issuance volume. This will be reviewed by Mercuria shortly',
    },
  },
};
